import { PluginKey } from '@atlaskit/editor-prosemirror/state';

export const closeHistoryKey: PluginKey = new PluginKey('closeHistory');
